import { render } from "./FaqBox.vue?vue&type=template&id=7b22efea&scoped=true"
import script from "./FaqBox.vue?vue&type=script&lang=js"
export * from "./FaqBox.vue?vue&type=script&lang=js"

import "./FaqBox.vue?vue&type=style&index=0&id=7b22efea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b22efea"]])

export default __exports__